import React from "react"
import Field from "./Field"
import "./Input.scss"

export default ({ label, type, id, name, value, handleChange, placeholder, error, isError = false, required }) => (
  <Field label={label} type={type} id={id} error={error} isError={isError}>
    <input className={`form__input form__input--${type}`} id={id} name={name} value={value} onChange={handleChange}
           placeholder={placeholder} type={type} required={required}/>
  </Field>
)